import { Tooltip } from "antd";
import moment from "moment/moment";
import React from "react";
import { NavLink } from "react-router-dom";
const SessionTimeline = ({
  showVisitButton,
  sessions,
  details,
  openRoute,
  selfies,
  openSelfies
}) => {
  return (
    <>
      {" "}
      <div className="card-header bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="mb-1">Session Timeline</h4>
          </div>
         
          <div className="session-summary">
            <span className="completed-badge mr-4">
              Completed :{" "}
              {sessions.filter((x) => x.status === "COMPLETED").length}
            </span>

            <span className="active-badge ms-2">
              Active : {sessions.filter((x) => x.status === "ACTIVE").length}
            </span>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="timeline">
          {details?.sessions?.length > 0 ? (
            details?.sessions?.map((item, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-dot">
                  {item?.status === "COMPLETED" ? (
                    <i className="fas fa-check"></i>
                  ) : (
                    <i className="fas fa-circle"></i>
                  )}
                </div>

                <div className="timeline-card">
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="session-time">
                        <span>
                          <i className="far fa-clock mr-1"></i>

                          {item?.checkInTime
                            ? moment
                                .utc(item?.checkInTime)
                                .local()
                                .format("hh:mm A")
                            : "-"}
                        </span>

                        <span className="mx-2">→</span>

                        <span>
                          {item?.checkOutTime &&
                          moment(item.checkOutTime).isValid()
                            ? moment
                                .utc(item.checkOutTime)
                                .local()
                                .format("hh:mm A")
                            : "-"}
                        </span>
                      </div>

                      <div className="session-meta mt-2">
                        <span>{item.distanceKm ?? 0} km </span>

                        <span>•</span>

                        <span>{item.visitCount ?? 0} Visits</span>

                        <span>•</span>

                        <span>
                          {" "}
                          {item.durationMinutes
                            ? `${Math.floor(item.durationMinutes / 60)}h ${item.durationMinutes % 60}m`
                            : "0m"}{" "}
                        </span>
                        <span>•</span>
                        <span>
                          <Tooltip title="Average Speed" placement="top">
                            {item.avgSpeed ?? 0} km/h
                          </Tooltip>
                        </span>
                        <span>•</span>
                        <span>
                          <Tooltip title="Maximum Speed" placement="top">
                            {item.maxSpeed ?? 0} km/h
                          </Tooltip>
                        </span>
                      </div>
                    </div>

                    <div className="align-items-center d-flex text-end w-300px">
                      <button
                        className={`btn btn-sm w-100 ${
                          item.status === "ACTIVE"
                            ? "bg-active-custom  text-white"
                            : "bg-success text-white"
                        }`}
                      >
                        {item.status}
                      </button>

                      <button
                        className="btn btn-sm view-route w-100"
                        onClick={() => openRoute(item)}
                      >
                        {item.status === "ACTIVE" ? "Route" : "Route"}
                      </button>

                      {showVisitButton &&
                        (!item?.visitCount ? (
                          <Tooltip placement="top" title="No visits available">
                            <span
                              className="btn btn-sm view-route w-100 disabled"
                              style={{
                                opacity: 0.6,
                                cursor: "not-allowed",
                              }}
                            >
                              Visits
                            </span>
                          </Tooltip>
                        ) : (
                          <NavLink
                            to={`/Visits/${item.sessionId}`}
                           
                            className="btn btn-sm view-route w-100"
                          >
                            Visits
                          </NavLink>
                        ))}

                    {/* <button
                        className="btn btn-sm view-route w-100"
                        onClick={() => openSelfies(item)}
                      >
                        Selfies
                      </button> */}
                    </div>
                  </div>
                  {/* <div className="timeline-line">
                    <img src={media?.dummy} alt="timeline-line" />
                  </div> */}
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">No data</p>
          )}
        </div>
      </div>
    </>
  );
};

export default SessionTimeline;
